module.exports = __webpack_public_path__ + "static/media/already_working_with_therapist.863d1c14.svg";